<template>
    <div>
        <div class="text-subtitle-1 font-weight-medium">{{ $t('select_method_of_payment') }}:</div>
        <div v-for="method in paymentMethods" :key="method.id">
            <v-checkbox
                v-model="formData.paymentMethods"
                hide-details
                :label="method.name"
                :value="method.id"
                density="compact"
            />
            <div class="font-italic" v-html="method.description" />
        </div>
    </div>
</template>
<script setup lang="ts">
    const formData = defineModel<any>()

    const isLoading = ref<boolean>(false)
    const paymentMethods = ref([])

    const {$api, $toast} = useNuxtApp()
    const {t} = useI18n()

    onMounted(async () => {
        await loadData()
        EventBus.$on(CHANGE_LOCALE_EVENT, loadData)
    })

    onBeforeUnmount(async () => {
        EventBus.$off(CHANGE_LOCALE_EVENT, loadData)
    })

    async function loadData(): Promise<void> {
        isLoading.value = true
        try {
            paymentMethods.value = (await $api.b2cPaymentMethods.get()).paymentMethods
        } catch (e) {
            $toast.error(t('error_message.load_error'))
        } finally {
            isLoading.value = false
        }
    }
</script>
